import { FC, useState, ReactElement } from 'react';
import { Box, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { DataGridActionType } from '@carcareers/utils';

import { DataGridActionMenu } from './DataGridActionMenu';

export interface TDataGridAction {
  label: string;
  onClick: (id?: number, row?: any) => void | (() => void) | Promise<unknown>;
  icon?: ReactElement;
  actionType?: DataGridActionType;
}

export interface DataGridActions {
  add?: TDataGridAction;
  edit?: TDataGridAction;
  delete?: TDataGridAction;
  view?: TDataGridAction;
  other?: {
    [key: string]: TDataGridAction;
  };
}

export interface DataGridActionProps {
  actions: DataGridActions;
  id: number;
  row?: any;
}

export const DataGridAction: FC<DataGridActionProps> = ({ actions, id, row }) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const open = Boolean(anchor);

  return (
    <>
      <Box>
        <IconButton onClick={(e) => setAnchor(e.currentTarget)} aria-label="Actions">
          <MoreVertIcon />
        </IconButton>
      </Box>
      <DataGridActionMenu id={id} row={row} open={open} onClose={() => setAnchor(null)} anchor={anchor} actions={actions} />
    </>
  );
};

export default DataGridAction;
